// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__w3F-C","item":"Select_item__3Stwl","select":"Select_select__2lWwq"};